import { useEffect, useState } from "react";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
} from "@material-ui/core";
// import { getAssessments } from './../services/api';

import { FaEdit, FaRegTrashAlt, FaArrowCircleRight } from "react-icons/fa";

function AssessmentsTable({ assessments, onEdit, onDelete, onEditData }) {
  function editAssessment(id) {
    console.log("edit assessment", id);
  }

  return (
    <div style={{ padding: "10px", height: "100%" }}>
      <Button
        variant="contained"
        color="primary"
        className="btn-main-limber mb-15"
        onClick={() => {
          onEdit({});
        }}
      >
        Create Assessment
      </Button>
      <TableContainer
        component={Paper}
        style={{
          overflow: "auto",
          height: "95%",
        }}
      >
        <Table stickyHeader sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Id</TableCell>
              <TableCell align="right">Name</TableCell>
              <TableCell align="right">Version</TableCell>
              <TableCell align="right">Edit</TableCell>
              <TableCell align="right">View</TableCell>
              <TableCell align="right">Delete</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {assessments.map((assessment) => {
              return (
                <TableRow key={assessment.id} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                  <TableCell component="th" scope="row">
                    {assessment.id}
                  </TableCell>
                  <TableCell align="right">{assessment.name}</TableCell>
                  <TableCell align="right">{assessment.version}</TableCell>
                  <TableCell align="right">
                    <FaEdit
                      className="icon-limber"
                      size="1.5em"
                      onClick={(evt) => {
                        onEditData(assessment);
                      }}
                    />
                  </TableCell>
                  <TableCell align="right">
                    <FaArrowCircleRight
                      className="icon-limber"
                      size="1.5em"
                      onClick={(evt) => {
                        onEdit(assessment);
                      }}
                    />
                  </TableCell>
                  <TableCell align="right">
                    <FaRegTrashAlt
                      className="icon-limber"
                      size="1.5em"
                      onClick={(evt) => {
                        onDelete(assessment);
                      }}
                    />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default AssessmentsTable;
